import './vehiculos.css';

export default function VehiculoMaintForm({ value, onChange, errors }) {
  const handleChange = (field, fieldValue) => {
    if (typeof onChange === 'function') {
      onChange({ ...value, [field]: fieldValue });
    }
  };

  return (
    <div className="form-section">
      <div className="form-field" data-error={Boolean(errors?.proximoServiceKm)}>
        <label htmlFor="vehiculo-service-km">Próximo service (km)</label>
        <input
          id="vehiculo-service-km"
          name="proximoServiceKm"
          type="number"
          min="0"
          value={value.proximoServiceKm ?? ''}
          onChange={event => handleChange('proximoServiceKm', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.proximoServiceKm && <span className="field-error">{errors.proximoServiceKm}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.proximoServiceFecha)}>
        <label htmlFor="vehiculo-service-fecha">Próximo service (fecha)</label>
        <input
          id="vehiculo-service-fecha"
          name="proximoServiceFecha"
          type="date"
          value={value.proximoServiceFecha ?? ''}
          onChange={event => handleChange('proximoServiceFecha', event.target.value)}
        />
        {errors?.proximoServiceFecha && <span className="field-error">{errors.proximoServiceFecha}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.estadoNeumaticos)}>
        <label htmlFor="vehiculo-neumaticos">Estado de neumáticos</label>
        <input
          id="vehiculo-neumaticos"
          name="estadoNeumaticos"
          value={value.estadoNeumaticos ?? ''}
          onChange={event => handleChange('estadoNeumaticos', event.target.value)}
          placeholder="70%"
        />
        {errors?.estadoNeumaticos && <span className="field-error">{errors.estadoNeumaticos}</span>}
      </div>

      <div className="form-field" data-error={Boolean(errors?.rotacionKm)}>
        <label htmlFor="vehiculo-rotacion">Rotación neumáticos (cada km)</label>
        <input
          id="vehiculo-rotacion"
          name="rotacionKm"
          type="number"
          min="0"
          value={value.rotacionKm ?? ''}
          onChange={event => handleChange('rotacionKm', event.target.value ? Number(event.target.value) : '')}
        />
        {errors?.rotacionKm && <span className="field-error">{errors.rotacionKm}</span>}
      </div>

      <div className="form-field dual-columns" data-error={Boolean(errors?.observaciones)}>
        <label htmlFor="vehiculo-observaciones">Observaciones técnicas</label>
        <textarea
          id="vehiculo-observaciones"
          name="observaciones"
          value={value.observaciones ?? ''}
          onChange={event => handleChange('observaciones', event.target.value)}
          rows={4}
        />
        {errors?.observaciones && <span className="field-error">{errors.observaciones}</span>}
      </div>
    </div>
  );
}
